module.exports = __webpack_public_path__ + "static/media/new-york.1a5de572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/new-york.jpg
// module id = 528
// module chunks = 0